/**
 * Fun loading messages shown while the app initializes.
 */
export const LOADING_MESSAGES = [
  'Waking up AI agents...',
  'Connecting to chat rooms...',
  'Teaching bots new jokes...',
  'Gathering virtual coffee...',
  'Optimizing chat protocols...',
  'Loading witty comebacks...',
  'Calibrating chat bubbles...',
  'Inviting digital friends...',
  'Assembling conversation starters...',
  'Bootstrapping virtual party hats...',
  'Tuning in to chatter frequency...',
  'Teaching bots empathy...',
  'Loading speech synthesis...',
  'Analyzing conversation history...',
  'Compiling digital etiquette...',
  'Summoning chat moderators...',
  'Decoding emoticons...',
  'Connecting virtual handshakes...',
  'Preparing digital icebreakers...',
  'Encrypting gossip channels...'
];

/**
 * Get a random loading message.
 */
export const getRandomLoadingMessage = () => {
  const randomIndex = Math.floor(Math.random() * LOADING_MESSAGES.length);
  return LOADING_MESSAGES[randomIndex];
};
